<template>
  <div>
    <partHeader :title="title"></partHeader>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="120px"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="第一学历" prop="firstEducation">
            <el-select
              v-model="form.firstEducation"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in options.educationList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="第一学历学位" prop="firstDegree">
            <el-select
              v-model="form.firstDegree"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in options.degreeList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="第一学历学制" prop="firstPeriod">
            <el-select
              v-model="form.firstPeriod"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in options.periodList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="第一学历毕业院校" prop="firstCollege">
            <el-input
              v-model="form.firstCollege"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="第一学历毕业时间" prop="firstGraduationDate">
            <el-date-picker
              v-model="form.firstGraduationDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :disabled="disabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="第一学历专业" prop="firstProfession">
            <el-input
              v-model="form.firstProfession"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="后续学历" prop="followEducation">
            <el-select
              v-model="form.followEducation"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in options.educationList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历学位" prop="followDegree">
            <el-select
              v-model="form.followDegree"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in options.degreeList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历学制" prop="followPeriod">
            <el-select
              v-model="form.followPeriod"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in options.periodList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="后续学历毕业院校" prop="followCollege">
            <el-input
              v-model="form.followCollege"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历毕业时间" prop="followGraduationDate">
            <el-date-picker
              v-model="form.followGraduationDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :disabled="disabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历专业" prop="followProfession">
            <el-input
              v-model="form.followProfession"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import partHeader from "./partHeader.vue";
import share from "@/assets/sharejs/share.js";
export default {
  components: {
    partHeader
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: "学习经历",
      validated: false,
      form: {
        firstEducation: "", //第一学历
        firstDegree: "", //第一学历学位
        firstPeriod: "", //第一学历学制
        firstCollege: "", //第一学历毕业院校
        firstGraduationDate: "", //第一学历毕业时间
        firstProfession: "", //第一学历专业
        followEducation: "", //后续学历
        followDegree: "", //后续学历学位
        followPeriod: "", //后续学历学制
        followCollege: "", //后续学历毕业院校
        followGraduationDate: "", //后续学历毕业时间
        followProfession: "" //后续学历专业
      },
      rules: {
        firstEducation: [
          { required: true, message: "请选择第一学历", trigger: "blur" }
        ],
        firstDegree: [
          { required: true, message: "请选择第一学历学位", trigger: "blur" }
        ],
        firstPeriod: [
          { required: true, message: "请选择第一学历学制", trigger: "blur" }
        ],
        firstCollege: [
          {
            required: true,
            message: "请填写第一学历毕业院校",
            trigger: "blur"
          }
        ],
        firstGraduationDate: [
          {
            required: true,
            message: "请填写第一学历毕业时间",
            trigger: "blur"
          }
        ],
        firstProfession: [
          { required: true, message: "请填写第一学历专业", trigger: "blur" }
        ]
      },
      options: {
        educationList: share.get("xl"),
        degreeList: share.get("xw"),
        periodList: share.get("xz")
      }
    };
  },
  mounted() {
    if (!this.$route.params.isTj) {
      this.form.firstEducation = this.item.dyxl;
      this.form.firstDegree = this.item.dyxlxw;
      this.form.firstPeriod = this.item.dyxlxw;
      this.form.firstCollege = this.item.dyxlbyxx;
      this.form.firstGraduationDate = this.dateFormat(this.item.dyxlbysj);
      this.form.firstProfession = this.item.dyxlzy;
      this.form.followEducation = this.item.hxxl;
      this.form.followDegree = this.item.hxxlxw;
      this.form.followPeriod = this.item.hxxlxz;
      this.form.followCollege = this.item.hxxlbyxx;
      this.form.followGraduationDate = this.dateFormat(this.item.hxxlbysj);
      this.form.followProfession = this.item.hxxlzy;
    }
  },
  methods: {
    validate() {
      this.validateForm();
      if (this.validated) {
        let para = {
          dyxl: this.form.firstEducation, //第一学历
          dyxlxw: this.form.firstDegree, //第一学历学位
          dyxlxz: this.form.firstPeriod, //第一学历学制
          dyxlbyxx: this.form.firstCollege, //第一学历毕业院校
          dyxlbysj: this.form.firstGraduationDate, //第一学历毕业时间
          dyxlzy: this.form.firstProfession, //第一学历专业
          hxxl: this.form.followEducation, //后续学历
          hxxlxw: this.form.followDegree, //后续学历学位
          hxxlxz: this.form.followPeriod, //后续学历学制
          hxxlbyxx: this.form.followCollege, //后续学历毕业院校
          hxxlbysj: this.form.followGraduationDate, //后续学历毕业时间
          hxxlzy: this.form.followProfession //后续学历专业
        };
        return para;
      }
      return null;
    },
    validateForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.validated = true;
        } else {
          this.validated = false;
        }
      });
    },
    reset() {
      this.$refs.form.resetFields();
    },
    dateFormat(date) {
      if (date) {
        return (
          date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2)
        );
      }
      return "";
    }
  }
};
</script>
